import { render, staticRenderFns } from "./EvaluationsCard.vue?vue&type=template&id=30387454"
import script from "./EvaluationsCard.vue?vue&type=script&lang=js"
export * from "./EvaluationsCard.vue?vue&type=script&lang=js"
import style0 from "./EvaluationsCard.vue?vue&type=style&index=0&id=30387454&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports